import { getLocale } from '@borealis/aurora';
import '@warp-ds/components/icon';
import { Alert, Button } from '@warp-ds/react';
import { useState } from 'react';
import { type AlertWidgetModel, InfoModalType } from '../../../types/widget.js';
import { RegtaxInfoModal } from '../modals/regtax-info.js';

type AlertWidgetProps = Omit<AlertWidgetModel, 'type'>;

export const AlertWidget = ({ text, title, alertType, links, infoModal, className, ...rest }: AlertWidgetProps) => {
  const [showInfoModal, setShowInfoModal] = useState(false);

  const modalMap = {
    [InfoModalType.REGTAX_INFO]: <RegtaxInfoModal open={showInfoModal} onDismiss={() => setShowInfoModal(false)} />,
  };

  return (
    <Alert {...rest} type={alertType} show className={`${className} items-center`}>
      {title && <div className="font-bold text-s mb-8">{title}</div>}
      {/* biome-ignore lint/security/noDangerouslySetInnerHtml: the markup has to render */}
      <span dangerouslySetInnerHTML={{ __html: text }} />{' '}
      {links?.map((link, _index) => (
        <a href={link.url} key={link.url} target="_blank" className="inline-flex" rel="noreferrer">
          {link.text} <w-icon name="LinkExternal" size="small" className="s-icon-primary ml-4" locale={getLocale()} />
        </a>
      ))}
      {infoModal && (
        <>
          <Button className="text-s" link onClick={() => setShowInfoModal(true)}>
            {infoModal.text}
          </Button>
          {modalMap[infoModal.type]}
        </>
      )}
    </Alert>
  );
};
